import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Nav, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import paths from 'routes/paths';

// Кнопка «Чат» в top-navbar. Раньше шла на paths.support (Логи) — но иконка
// comments + название «Поддержка» путали пользователя: оператор кликал
// ожидая chat, попадал на лог-таблицу. По требованию: эта кнопка теперь
// ведёт прямо на support-chat (paths.chat). Логи поддержки остались в
// sidebar (Поддержка → Логи).
//
// Гейт по access supportChatView — без права на чат кнопка не отображается
// (тот же гейт, что у sidebar-пункта siteMaps.js и backend
// /chat/v1/sso-token).
//
// Badge с unread-count появится в Phase 3 — когда chat-backend будет
// отдавать «у этого оператора N непрочитанных диалогов» (через REST/WS).
// Сейчас просто иконка → переход на страницу.

const renderTooltip = props => (
  <Tooltip style={{ position: 'fixed' }} id="chat-button-tooltip" {...props}>
    Чат поддержки
  </Tooltip>
);

const SupportButton = () => {
  return (
    <OverlayTrigger placement="bottom" overlay={renderTooltip}>
      <Nav.Item as="li" className="m-0">
        <Nav.Link as={Link} to={paths.chat} className="px-0">
          <FontAwesomeIcon
            icon="comments"
            transform="shrink-7"
            className="fs-5"
          />
        </Nav.Link>
      </Nav.Item>
    </OverlayTrigger>
  );
};

export default SupportButton;
